/* global wpConfig */

export default {
    es: {
        host: wpConfig.handler_url + 'jbs/v2/search'
    },
    wp: {
        host: wpConfig.handler_url.replace(/\/$/, "")
    }
}
